import { useState } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';

interface Props {
  isOpen: boolean;
  tenantCode: string;
  onConfirm: () => void;
  onClose: () => void;
}

export function TenantSuspendModal({ isOpen, tenantCode, onConfirm, onClose }: Props) {
  const [typed, setTyped] = useState('');
  if (!isOpen) return null;

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200 }} />
      <div role="dialog" aria-modal="true" style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        background: 'var(--vp-surface)', padding: 24, borderRadius: 8, zIndex: 201, maxWidth: 480,
      }}>
        <h5 className="fs-16 mb-2">Sospendere <code>{tenantCode}</code>?</h5>
        <p>Effetti immediati:</p>
        <ul>
          <li>Tutti gli operatori non potranno più loggarsi.</li>
          <li>Tutti i tenant-admin non potranno più gestire il tenant.</li>
          <li>Sessioni voce attive vengono terminate.</li>
          <li>Pick-list non possono essere importate.</li>
        </ul>
        <FormGroup style={{ marginTop: 16 }}>
          <Label for="tsm-code" className="mb-1">Per confermare, scrivi il code del tenant:</Label>
          <Input id="tsm-code" value={typed} onChange={(e) => setTyped(e.target.value)} autoFocus />
        </FormGroup>
        <div className="d-flex justify-content-end gap-2" style={{ marginTop: 16 }}>
          <Button type="button" color="light" size="sm" onClick={onClose}>Annulla</Button>
          <Button
            type="button"
            color="danger"
            size="sm"
            disabled={typed !== tenantCode}
            onClick={onConfirm}
          >Conferma sospensione</Button>
        </div>
      </div>
    </>
  );
}
